/** Workspace limits use binary MiB; the host quota helper owns persistence and enforcement. */
export const DEFAULT_WORKSPACE_QUOTA_BYTES = 256 * 1024 ** 2;
export const WORKSPACE_QUOTA_MIN_BYTES = 1024 ** 2;
export const WORKSPACE_QUOTA_MAX_BYTES = 1024 ** 4;

export interface WorkspaceQuotaUpdate {
  limitBytes: number;
  /** Last read effective limit. Stale administrators must refresh before saving. */
  expectedLimitBytes: number;
}

export function validWorkspaceQuotaBytes(value: unknown): value is number {
  return typeof value === 'number' && Number.isSafeInteger(value)
    && value >= WORKSPACE_QUOTA_MIN_BYTES && value <= WORKSPACE_QUOTA_MAX_BYTES
    && value % WORKSPACE_QUOTA_MIN_BYTES === 0;
}
